import { FC, useEffect } from 'react';
import useNavigateTo from 'hooks/useNavigateTo';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectBanner } from 'store/pages/pagesSelectors';
import IQuiz from 'models/Quiz';
// Components
import Dialog from 'components/Dialog';
import Video from 'components/Video';
import AppBar from 'components/AppBar';
import PoweredBy from 'components/PoweredBy';

type Props = {
  onClose: () => void;
}

const VideoDialog:FC<Props> = ({
  // Props
  onClose
}) => {
  const quiz:IQuiz | null = useAppSelector(selectQuiz);
  const banner = useAppSelector(selectBanner);

  const navigateTo = useNavigateTo();

  const onEndedCallback = () => {
    onClose();
    navigateTo('pages-handler');
  }

  useEffect(() => {
    if (!banner.source) navigateTo('pages-handler');
    // eslint-disable-next-line
  }, []);

  if (!banner.source) return null;
  return (
    <Dialog
      classes="p-4"
      background={quiz?.backgroundImage ? `url('${quiz.backgroundImage}') center / cover` : '#000'}
    >
      <AppBar />
      <div className="py-4 flex-1 flex flex-col items-center justify-center gap-6">
        {banner.title ? (
          <h2 className="text-xl font-bold text-primary text-center">{banner.title}</h2>
        ) : null}
        <div className="shadow-primary rounded-lg overflow-hidden">
          <Video
            videoUrl={banner.source}
            onEndedCallback={onEndedCallback}
          />
        </div>
      </div>
      <PoweredBy />
    </Dialog>
  )
}

export default VideoDialog;